<div class="page-content page-fill">
  <div class="grid-fill">
    @if (emails) {
      <div  class="agenda-data-grid p-3">
        <dx-data-grid
          #dataGrid
          [dataSource]="emails"
          keyExpr="id"
          class="flex-fill"
          [showBorders]="true"
          [columnAutoWidth]="false"
          [focusedRowEnabled]="false"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          >
          <dxi-column dataField="sent"></dxi-column>
          <dxi-column dataField="sentToHtml" caption="Sent To" width="250" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
          <dxi-column dataField="attachmentList" caption="Attachments" width="550" [encodeHtml]="false" [allowSearch]="true"></dxi-column>
          <dxi-column dataField="created"></dxi-column>
          <dxi-column dataField="createdBy"></dxi-column>
          <dxo-state-storing [enabled]="true" type="localStorage" storageKey="emails-grid"></dxo-state-storing>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-search-panel [visible]="false"></dxo-search-panel>
          <dxo-selection [mode]="'single'" showCheckBoxesMode="true"></dxo-selection>
          <div *dxTemplate="let data of 'toolbarButtons'">
          </div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (emails) {
              <span class="me-3">
                <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    }
  </div>
</div>
